// Leaderboard row → public Player Profile (canonical guestId, never nickname).
// Delegated listener so the approved row markup/geometry stays untouched;
// stores the board scroll so Back lands on the same spot.
import { useEffect } from 'react';
import { loadGuest } from '@/lib/guestIdentity';

const KEY = 'kickard.boardScroll';

export function profilePathFor(guestId) {
  const me = loadGuest()?.guestId;
  return guestId && guestId === me ? '/profile/me' : `/profile/${encodeURIComponent(guestId)}`;
}

export function usePlayerRowLinks(navigate) {
  useEffect(() => {
    const open = (row) => {
      const gid = row?.getAttribute('data-guestid');
      if (!gid) return;
      try { sessionStorage.setItem(KEY, JSON.stringify({ path: window.location.pathname, y: window.scrollY })); } catch (_) { /* ignore */ }
      navigate(profilePathFor(gid));
    };
    const onClick = (e) => open(e.target.closest?.('.kst__row[data-guestid]'));
    const onKey = (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const row = e.target.closest?.('.kst__row[data-guestid]');
      if (row) { e.preventDefault(); open(row); }
    };
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);

    let raf = 0;
    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (_) { saved = null; }
    if (saved && saved.path === window.location.pathname && saved.y > 0) {
      const until = Date.now() + 2500;
      const tick = () => {
        if (document.documentElement.scrollHeight >= saved.y + window.innerHeight || Date.now() > until) {
          window.scrollTo(0, saved.y);
          try { sessionStorage.removeItem(KEY); } catch (_) { /* ignore */ }
          return;
        }
        raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    }
    return () => {
      document.removeEventListener('click', onClick);
      document.removeEventListener('keydown', onKey);
      cancelAnimationFrame(raf);
    };
  }, [navigate]);
}
